import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { ConfirmRegistrationConstants } from '../constants/confirm-registration.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DomainWhitelistService } from '../../../../core/routing/services/users/domain-whitelist.service';
import { DataService } from '../../../../core/data/data-service';
import { first } from 'rxjs/internal/operators/first';
import { AccountCreatedConstants } from './constants/account-created.const';
import { GoogleAnalyticsService } from '../../../..//modules/google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-account-created',
  templateUrl: './account-created.component.html',
  styleUrls: ['./account-created.component.scss']
})
export class AccountCreatedComponent implements OnInit, OnDestroy {  
  modalTitle: string;
  firstName: string;
  emailNotification: string;
  loginhref: string;
  href: string;
  activeStatus: string;
  isUserConnected: boolean;
  isAccountApproved: boolean;
  searchData: string;
  private sub: any;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private domainWhiteListService: DomainWhitelistService,
    private dataService: DataService,
    private googleAnalyticsService:GoogleAnalyticsService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate([RouterConstants.HOME_PAGE_LINK]);
      sessionStorage.removeItem('userId');
    }, AccountCreatedConstants.AUTO_CLOSING_SECONDS);
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.href = RouterConstants.HOME_PAGE_LINK;
    this.firstName = sessionStorage.getItem('firstName');
    this.emailNotification = sessionStorage.getItem('email');
    this.sub = this.route.params.subscribe(params => {
      this.activeStatus = params.activestatus;
    });
    this.dataService.getIsUserConnected()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.isUserConnected = res;
    });
    this.checkIsAccountApporved();
    // gtm(google tag manager)
    window['dataLayer'].push({
      'account_created_successfully': true
      });
  }

  close(): void {
    this.router.navigate([RouterConstants.HOME_PAGE_LINK]);
  } 

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setModelTitleAndBody(isApproved) {
    this.modalTitle = isApproved ? ConfirmRegistrationConstants.ACCOUNT_CREATED
      : ConfirmRegistrationConstants.ACCOUNT_REQUESTED;
  }

  checkIsAccountApporved() {
    this.isAccountApproved = (this.activeStatus === ConfirmRegistrationConstants.CREATED_USER_STATUS_ACTIVE) ? true : false;
      this.setModelTitleAndBody(this.isAccountApproved);
  }
}
